export const RESET = 'EXCMCHATBOT_LIST_RESET'
export const SET_ITEMS = 'EXCMCHATBOT_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMCHATBOT_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMCHATBOT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMCHATBOT_LIST_TOGGLE_LOADING'
